import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { authService } from '../services/api';
import { getCookie, deleteCookie } from '../utils/cookies';

const ProtectedRoute = ({ children }) => {
	const { isAuthenticated, loading, refreshUserData } = useAuth();
	const [checking, setChecking] = useState(true);
	const [hasAccess, setHasAccess] = useState(false);
	const location = useLocation();

	useEffect(() => {
		// Kiểm tra quyền truy cập mỗi khi chuyển màn hình
		const checkAccess = async () => {
			const token = getCookie('token');

			if (!token) {
				setHasAccess(false);
				setChecking(false);
				return;
			}

			try {
				// Gọi API who-am-i để kiểm tra quyền
				const response = await authService.whoAmI();

				if (response.success && response.data) {
					setHasAccess(true);
					// Lưu thông tin user vào localStorage
					localStorage.setItem('user', JSON.stringify(response.data));
				} else {
					setHasAccess(false);
				}
			} catch (error) {
				console.error('Access check failed:', error);
				setHasAccess(false);
				// Xóa token nếu không hợp lệ
				deleteCookie('token');
				deleteCookie('refreshToken');
				localStorage.removeItem('user');
			} finally {
				setChecking(false);
			}
		};

		checkAccess();
	}, [location.pathname]);

	// Đợi AuthContext load xong
	if (loading) {
		return (
			<Box
				sx={ {
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					minHeight: '80vh',
				} }
			>
				<CircularProgress />
			</Box>
		);
	}

	// Đợi kiểm tra quyền truy cập
	if (checking) {
		return (
			<Box
				sx={ {
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					minHeight: '80vh',
				} }
			>
				<CircularProgress />
			</Box>
		);
	}

	// Nếu không có quyền, redirect về login
	if (!isAuthenticated || !hasAccess) {
		return <Navigate to="/login" replace />;
	}

	return children;
};

export default ProtectedRoute;
